import Web3 from "../components/Home/Web3";
import PreSale from "../components/Home/PreSale";
import WebSecurity from "../components/Home/WebSecurity";
import Staking from "../components/Home/Staking";
import Live from "../components/Home/Live";
import Ciphegis from "../components/Home/Ciphegis";
import RoadMap from "../components/Home/RoadMap";
import Supply from "../components/Home/Supply";
import AnimatedSection from "../components/AnimatedSection";
import TeamWork from "../components/Home/TeamWork";
import Partners from "../components/Home/Partners";
import { useEffect } from "react";
import "../i18n";

const IndexOne = () => {
  // Add scroll restoration
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full mx-auto min-h-screen overflow-x-hidden">
      <div className="space-y-16 md:space-y-24">
        <AnimatedSection delay={0.1} threshold={0.1}>
          <Web3 />
        </AnimatedSection>
        <AnimatedSection delay={0.1} threshold={0.1}>
          <WebSecurity />
        </AnimatedSection>
        <AnimatedSection delay={0.1} threshold={0.1}>
          <PreSale />
        </AnimatedSection>
        <AnimatedSection delay={0.1} threshold={0.1}>
          <Live />
        </AnimatedSection>
        <AnimatedSection delay={0.1} threshold={0.1}>
          <Ciphegis />
        </AnimatedSection>
        <AnimatedSection delay={0.1} threshold={0.1}>
          <Supply />
        </AnimatedSection>
        <AnimatedSection delay={0.1} threshold={0.1}>
          <Staking />
        </AnimatedSection>
        <AnimatedSection delay={0.1} threshold={0.1}>
          <TeamWork />
        </AnimatedSection>
        <AnimatedSection delay={0.1} threshold={0.1}>
          <Partners />
        </AnimatedSection>
        <AnimatedSection delay={0.1} threshold={0.1}>
          <RoadMap />
        </AnimatedSection>
      </div>
    </div>
  );
};

export default IndexOne;